var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63.9741,
    height: 63.9741,
    rx: 31.987,
    fill: "#E6F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6092 46.3762H44.1593V30.9885H33.6092V46.3762ZM20.6362 46.3762H31.1863V30.9885H20.6362V46.3762ZM15.7482 28.5637L32.3988 12.5133L49.0494 28.5637H15.7482ZM50.5851 46.3762H46.5841V30.9885H49.5868C50.4921 30.9885 51.2984 30.445 51.6358 29.6044C51.9753 28.7637 51.7712 27.816 51.1185 27.1876L33.9325 10.6239C33.0676 9.79136 31.7198 9.79338 30.8671 10.6219L13.679 27.1876C13.0263 27.816 12.8242 28.7637 13.1637 29.6044C13.5011 30.445 14.3054 30.9885 15.2106 30.9885H18.2154V46.3762H14.2124C13.5436 46.3762 13 46.9177 13 47.5886C13 48.2595 13.5436 48.801 14.2124 48.801H50.5851C51.2539 48.801 51.7975 48.2595 51.7975 47.5886C51.7975 46.9177 51.2539 46.3762 50.5851 46.3762Z",
    fill: "#425466"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bank_icon.24bf8254b4c70c7ae95f267d1b47ea2f.svg";
export { ForwardRef as ReactComponent };